module.exports = __webpack_public_path__ + "img/img_tip.f08f1544.png";